import { useEffect, useState } from "react";
import Desktop from "./desktop";
import Mobile from "./mobile";

const ScrollTop = (props) => {

	const prop = props;
	const [bottom, setBottom] = useState(16);

	useEffect(() => {

		let heightWidget = 0;
		let heightAdsBanner = 0;

		if (document.getElementById("videoWidgetStreaming")) {

			heightWidget = document.getElementById("videoWidgetStreaming").offsetHeight;

		}

		if (document.getElementById("sb_mobile_sticky")) {

			heightAdsBanner = document.getElementById("sb_mobile_sticky").offsetHeight;

		}

		setBottom(heightWidget + heightAdsBanner + 16);

	}, []);

	if (prop.isMobile) {

		return (
			<Mobile
				{...prop}
				bottom={bottom}
			/>
		);

	}

	return (
		<Desktop
			{...prop}
		/>
	);

};

export default ScrollTop;
